// removed by extract-text-webpack-plugin
module.exports = {"underlined":"_1B7es","main":"_2O1VL","content_wrapper":"l3CHE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Layout.css
// module id = 615
// module chunks = 0